import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface TemperatureListState {
    list: any,
  }
  
const initialState:TemperatureListState = {
    list: undefined,
}

export const temperaturelistSlice = createSlice({
    name:"temperatureList",
    initialState,
    reducers:{
        UpdateTemperatureList: (state,action) => {
            state.list = action.payload.temperatureList;
        },
        AddTemperature: (state,action) => {
            state.list = undefined;
        },
        EditTemperature: (state,action) => {
            state.list = undefined;
        },
        RemoveTemperature: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateTemperatureList,AddTemperature,EditTemperature,RemoveTemperature} = temperaturelistSlice.actions

export const selecttemperatureList = (state: RootState) => state.temperatureList

export default temperaturelistSlice.reducer;